"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  AGG_DEMOGRAPHICS: 'aggDemographics',
  DETAILS: 'details',
  ADMINISTRATION: 'administration',
  QUALIFICATIONS: 'qualifications',
  QUALIFICATIONS_OTHERS: 'qualificationsOthers'
};
exports.default = _default;